import React from 'react';
import PropTypes from 'prop-types';

import {Box, Skeleton, Stack, Typography} from 'views/components';
import {Translate, translate} from 'views/module';

import TaskItem from '../../../tasks/all_tasks/components/TaskItem';

const RecentInvocations = (props) => {
  const {tasks = [], isLoading} = props;

  return (
    <Stack
      sx={{
        gap: '10px',
        width: '100%',
        height: '100%',
        minHeight: 0,
      }}
    >
      <Stack
        direction='row'
        sx={{
          border: '1px solid #E8E4DE',
          borderRadius: '12px',
          backgroundColor: '#FFFFFF',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            flex: 1,
            px: '18px',
            py: '14px',
            display: 'flex',
            flexDirection: 'column',
            gap: '4px',
          }}
        >
          <Typography
            sx={{
              fontSize: '12px',
              fontWeight: 400,
              color: '#A8A49E',
              lineHeight: '150%',
            }}
          >
            <Translate expression='automations.Automations.View.RecentInvocations.Summary.Invocations' />
          </Typography>
          {
            isLoading &&
              <Skeleton width={40} height={36} />
          }
          {
            !isLoading &&
              <Typography
                sx={{
                  fontSize: '16px',
                  fontWeight: 500,
                  color: '#1A1916',
                  lineHeight: '110%',
                }}
              >
                {tasks.length > 100 ? translate('automations.Automations.View.RecentInvocations.Summary.MaxInvocations') : tasks.length}
              </Typography>
          }
        </Box>
        <Box
          sx={{
            width: '1px',
            backgroundColor: '#E8E4DE',
            alignSelf: 'stretch',
          }}
        />
        <Box
          sx={{
            flex: 1,
            px: '18px',
            py: '14px',
            display: 'flex',
            flexDirection: 'column',
            gap: '4px',
          }}
        >
          <Typography
            sx={{
              fontSize: '12px',
              fontWeight: 400,
              color: '#A8A49E',
              lineHeight: '150%',
            }}
          >
            <Translate expression='automations.Automations.View.RecentInvocations.Summary.Model' />
          </Typography>
          {
            isLoading &&
              <Skeleton width={170} height={36} />
          }
          {
            !isLoading &&
              <Typography
                sx={{
                  fontSize: '16px',
                  fontWeight: 500,
                  color: '#1A1916',
                  lineHeight: '110%',
                }}
              >
                <Translate expression='automations.Automations.View.RecentInvocations.Summary.ModelValue' />
              </Typography>
          }
        </Box>
      </Stack>
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          overflowY: 'auto',
        }}
      >
        {
          isLoading &&
            <Stack
              sx={{
                mt: '16px',
                gap: '8px',
              }}
            >
              <Skeleton
                width={140}
                height={11}
                sx={{
                  transform: 'none',
                }}
              />
              {
                [0, 1, 2].map((index) => {
                  return (
                    <Skeleton
                      key={index}
                      variant='rounded'
                      height={74}
                      sx={{borderRadius: '12px'}}
                    />
                  );
                })
              }
            </Stack>
        }
        {
          !isLoading && tasks.length > 0 &&
            <Stack
              sx={{
                mt: '16px',
                gap: '8px',
              }}
            >
              <Typography
                sx={{
                  fontSize: '11px',
                  fontWeight: 600,
                  color: '#A8A49E',
                  lineHeight: '100%',
                  textTransform: 'uppercase',
                }}
              >
                <Translate expression='automations.Automations.View.RecentInvocations.Title' />
              </Typography>
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: 'minmax(0, 1.2fr) minmax(0, 1fr) auto',
                  columnGap: 2,
                  alignItems: 'center',
                  width: '100%',
                }}
              >
                {
                  tasks.map((task) => {
                    return (
                      <TaskItem
                        key={task.taskRn}
                        task={task}
                        isHoverToolboxEnabled={false}
                        isDueDatePickerEnabled={false}
                      />
                    );
                  })
                }
              </Box>
            </Stack>
        }
      </Box>
    </Stack>
  );
};

RecentInvocations.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  tasks: PropTypes.array,
};

export default React.memo(RecentInvocations);
